export const YesNoTranslations: Readonly<Record<`${boolean}`, string>> = {
  get ["false"](): string {
    return $localize`:@@boolean.false:No`;
  },
  get ["true"](): string {
    return $localize`:@@boolean.true:Yes`;
  },
};

export function translateYesNo(value: boolean): string {
  return YesNoTranslations[`${value}`];
}
